module.exports = __webpack_public_path__ + "img/background2.88c5b97a.jpg";